export default __webpack_public_path__ + "static/media/temperature.3dd626b1.png";